// Quick Actions Component
// Call, Text, Email buttons for quick client contact

import { Button } from '@/components/ui/button';
import { PhoneCall, MessageCircle, Mail } from 'lucide-react';

const QuickActions = ({ clientPhone, clientEmail }) => {
  if (!clientPhone && !clientEmail) return null;

  return (
    <div className="mt-4 pt-4 border-t border-slate-200">
      <p className="text-xs text-slate-500 uppercase tracking-wide mb-3">Quick Actions</p>
      <div className="flex flex-col sm:flex-row gap-3">
        {clientPhone && (
          <>
            <a 
              href={`tel:${clientPhone.replace(/\D/g, '')}`}
              className="flex-1"
              data-testid="call-client-btn"
            >
              <Button 
                className="w-full bg-emerald-500 hover:bg-emerald-600 text-white"
                size="lg"
              >
                <PhoneCall className="w-5 h-5 mr-2" />
                Call Now
              </Button>
            </a>
            <a 
              href={`sms:${clientPhone.replace(/\D/g, '')}`}
              className="flex-1"
              data-testid="text-client-btn"
            >
              <Button 
                variant="outline"
                className="w-full border-teal-500 text-teal-600 hover:bg-teal-50"
                size="lg"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                Text Client
              </Button>
            </a>
          </>
        )}
        {clientEmail && (
          <a 
            href={`mailto:${clientEmail}?subject=Re: Your Injury Case Consultation`}
            className="flex-1"
            data-testid="email-client-btn"
          >
            <Button 
              variant="outline"
              className="w-full border-blue-500 text-blue-600 hover:bg-blue-50"
              size="lg"
            >
              <Mail className="w-5 h-5 mr-2" />
              Email Client
            </Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default QuickActions;
